import { render, staticRenderFns } from "./ComSpecModel.vue?vue&type=template&id=3c7a8dd6&scoped=true&"
import script from "./ComSpecModel.vue?vue&type=script&lang=js&"
export * from "./ComSpecModel.vue?vue&type=script&lang=js&"
import style0 from "./ComSpecModel.vue?vue&type=style&index=0&id=3c7a8dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a8dd6",
  null
  
)

export default component.exports